/**
 * Normalize a raw organization record from the AI-Scribe backend so the UI can
 * rely on both `id` and `organizationId` being present.
 *
 * The backend's hash key is `organizationId`; the admin grid + getRowId code
 * (forked from the IAM admin) keys on `id`. This bridges the two without the
 * backend having to emit a duplicate field. Falls back to `name` only if no id
 * is present at all.
 */
export function normalizeOrg<T extends Record<string, any>>(raw: T): T & { id: string; organizationId: string } {
  const organizationId = raw?.organizationId ?? raw?.id ?? raw?.name ?? '';
  return { ...raw, organizationId, id: organizationId };
}
